import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "store-locator-filter"
}
const _hoisted_2 = { style: {"position":"sticky","top":"0"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "header-filters" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "container-custom",
    style: {"text-align":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "h1-custom" }, "Cerca il tuo rivenditore Marlù")
  ])
], -1)
const _hoisted_4 = { class: "filters" }
const _hoisted_5 = { class: "container-custom" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Filtri di ricerca ")
const _hoisted_7 = {
  key: 0,
  class: "filters-container"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, " Filtra per: ", -1)
const _hoisted_9 = { class: "d-flex" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_11 = { class: "ms-auto" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Cerca ")
const _hoisted_13 = {
  key: 0,
  class: "container-custom number-results"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Switcher = _resolveComponent("Switcher")!
  const _component_CountrySelect = _resolveComponent("CountrySelect")!
  const _component_StoreLocatorResult = _resolveComponent("StoreLocatorResult")!

  return (_ctx.isMounted)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h3", {
                class: "cursor-pointer text-uppercase",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onToggleFilters && _ctx.onToggleFilters(...args)))
              }, [
                _hoisted_6,
                (_ctx.showFilters)
                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 0,
                      class: "float-end",
                      icon: _ctx.FaAngleUp
                    }, null, 8, ["icon"]))
                  : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 1,
                      class: "float-end",
                      icon: _ctx.FaAngleDown
                    }, null, 8, ["icon"]))
              ]),
              (_ctx.showFilters)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode(_component_Switcher, {
                      active: _ctx.franchising,
                      filters: _ctx.switchFilters,
                      onChange: _ctx.onChangeFilter
                    }, null, 8, ["active", "filters", "onChange"]),
                    _createVNode(_component_CountrySelect, { onChange: _ctx.onChangeCountry }, null, 8, ["onChange"]),
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("button", {
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFindStoreLocators && _ctx.onFindStoreLocators(...args))),
                          class: "hover text-uppercase btn btn-naked text-white mb-2 mt-4"
                        }, [
                          (_ctx.isLoading)
                            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                key: 0,
                                class: "fa-spin me-2",
                                icon: _ctx.FaSpinner
                              }, null, 8, ["icon"]))
                            : _createCommentVNode("", true),
                          _hoisted_12,
                          _createVNode(_component_font_awesome_icon, {
                            class: "ms-2",
                            icon: _ctx.FaCaretRight
                          }, null, 8, ["icon"])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.dirty)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.numberResultText), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_StoreLocatorResult, { dirty: _ctx.dirty }, null, 8, ["dirty"])
      ]))
    : _createCommentVNode("", true)
}